import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../contexts/LanguageContext';
interface HeroProps {
  onScrollToSection: (sectionId: string) => void;
}
export function Hero({
  onScrollToSection
}: HeroProps) {
  const {
    t
  } = useLanguage();
  return <section className="relative w-full overflow-hidden bg-white pt-20" data-id="element-244" data-mp="9ih0dmtnseqi">
      {/* Subtle grain texture */}
      <div className="absolute inset-0 opacity-[0.03] pointer-events-none" style={{
      backgroundImage: 'url("data:image/svg+xml,%3Csvg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg"%3E%3Cfilter id="noiseFilter"%3E%3CfeTurbulence type="fractalNoise" baseFrequency="0.9" numOctaves="3" stitchTiles="stitch"/%3E%3C/filter%3E%3Crect width="100%25" height="100%25" filter="url(%23noiseFilter)"/%3E%3C/svg%3E")'
    }} data-id="element-245" data-mp="129h6c3bjvskt" />
      <div className="relative z-10 max-w-5xl mx-auto px-6 pt-12 pb-24 text-center" data-id="element-246" data-mp="3czfkty10i55i">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="mb-10 flex flex-col items-center gap-4" data-id="element-247" data-mp="380w0u35zb3fs">
          <p className="text-xs font-mono tracking-wider uppercase text-gray-600" data-id="element-248" data-mp="39a32ynlycrgz">
            {t('hero.badge')}
          </p>
          <button onClick={() => onScrollToSection('waitlist')} className="w-full sm:w-auto px-12 py-4 bg-black text-white font-black text-base hover:bg-gray-900 border-2 border-black transition-colors duration-200 uppercase tracking-widest rounded-full whitespace-nowrap" data-id="element-249" data-mp="30i19586e29fo">
            {t('hero.cta.primary')}
          </button>
        </motion.div>

        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.1
      }} className="text-7xl md:text-8xl lg:text-[12rem] font-black text-black mb-8 leading-none tracking-tighter uppercase" style={{
        fontFamily: 'system-ui, -apple-system, sans-serif',
        fontStretch: 'condensed'
      }} data-id="element-250" data-mp="2vgllr9gqnqu4">
          NEURO
          <span className="inline-block border-b-8 border-gray-300" data-id="element-251" data-mp="de6o0r03e1ks">SPICE</span>
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="text-3xl md:text-4xl text-black mb-6 max-w-2xl mx-auto font-light tracking-wide" data-id="element-252" data-mp="1azuktd0gmlwu">
          {t('hero.tagline')}
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.25
      }} className="mb-8" data-id="element-253" data-mp="3luiaiu6w15my">
          <p className="text-xl md:text-2xl text-black font-medium max-w-2xl mx-auto leading-relaxed" data-id="element-254" data-mp="21bftfk4bp5rt">
            {t('hero.hook')}
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.3
      }} className="mb-16" data-id="element-255" data-mp="2b0zduu7op7os">
          <p className="text-lg text-black mb-3 max-w-2xl mx-auto leading-relaxed" data-id="element-256" data-mp="2p08tnsrz9zs8">
            {t('hero.subtitle')}
          </p>
          <p className="text-sm text-gray-600 max-w-xl mx-auto" data-id="element-257" data-mp="2tz1ykwt78igs">
            {t('hero.impact')}
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.8,
        delay: 0.5
      }} className="mt-16" data-id="element-258" data-mp="uou4bd2vq2d0">
          <img src="https://cdn.magicpatterns.com/uploads/2Kp6hwP7Bx17yXgSMLHC1K/Fries_with_Function_Hero_Energy.png" alt={t('hero.image.alt')} className="mx-auto max-w-2xl w-full aspect-square object-cover rounded-lg shadow-2xl" data-id="element-259" data-mp="e9k1u6batvxp" />
        </motion.div>
      </div>
    </section>;
}